const medicineProductAf = {
  breadcrumbs: {
    home: 'کور',
    medicineBazar: 'د درملو بازار'
  },
  loading: 'بار کول...',
  labels: {
    prescriptionRequired: 'د نسخې اړتیا',
    reviewsSuffix: 'تبصرې',
    deliveryPrefix: 'لېږد:',
    minOrderPrefix: 'د لږترلږه امر:',
    perUnitPrefix: 'د هر',
    expiry: 'د پای موده:',
    stock: 'ذخیره:',
    inStock: 'په ذخیره کې',
    outOfStock: 'له ذخیرې بهر',
    availableUnitsSuffix: 'شته',
    selectQuantity: 'د مقدار انتخاب:',
    unitLabel: 'واحد',
    unitStrip: 'پټۍ',
    unitBox: 'بکس',
    unitTablet: 'ګولۍ',
    unitBottle: 'بوتل',
    unitVial: 'ویال',
    unitAmpule: 'امپول',
    unitTube: 'ټیوب',
    unitSachet: 'ساشه',
    unitInhaler: 'د تنفس وسیله',
    perUnitNotePrefix: '* د هر',
    totalAmountPrefix: 'مجموعه:',
    addToCart: 'په کڅوړه کې اضافه کړئ',
    wishlistAria: 'په لیست کې اضافه کړئ',
    shareAria: 'شریک کړئ',
    descriptionTab: 'تفصیل',
    specsTab: 'مشخصات',
    reviewsTab: 'تبصرې',
    productDescriptionTitle: 'د درمل تفصیل',
    productSpecsTitle: 'د درمل مشخصات',
    customerReviewsTitle: 'د پیرودونکو تبصرې',
    relatedTitle: 'اړونده درمل',
  },
  messages: {
    addedToCart: 'په کڅوړه کې اضافه شو!',
    orderInfo: 'ټول درمل له لایسنس لرونکو فارمسیو څخه چمتو کیږي...'
  }
};

export default medicineProductAf;
